import { render, staticRenderFns } from "./AskNikoCard.vue?vue&type=template&id=346fe8c7&scoped=true&"
import script from "./AskNikoCard.vue?vue&type=script&lang=js&"
export * from "./AskNikoCard.vue?vue&type=script&lang=js&"
import style0 from "./AskNikoCard.vue?vue&type=style&index=0&id=346fe8c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346fe8c7",
  null
  
)

export default component.exports